import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { VimeoUnavailablePlaceholderSize } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo-enum';

@Component({
    selector: 'fi-vimeo-unavailable-video-handler',
    template: `
        <div class="fi-vimeo-player-not-available-container">
            <mat-icon class="fi-vimeo-player-not-available-icon fas fa-file-video BrandedColor" />
            <p class="fi-vimeo-player-not-available-header">{{ getNotAvailableHeader() }}</p>
            <p class="fi-vimeo-player-not-available-text">{{ getNotAvailableText() }}</p>
        </div>
    `,
    styleUrls: ['./fi-vimeo-unavailable-video-handler.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-vimeo-unavailable-video-handler' },
    standalone: false,
})
export class FiVimeoUnavailableVideoHandlerComponent {
    @Input() placeholderSize: VimeoUnavailablePlaceholderSize = VimeoUnavailablePlaceholderSize.Small;
    @HostBinding('class') get className(): string {
        return this.placeholderSize;
    }

    constructor(private appTextService: AppTextService) {}

    protected getNotAvailableHeader(): string {
        return this.appTextService.get('file.video_processing_text');
    }

    protected getNotAvailableText(): string {
        return this.appTextService.get('file.video_processing_description');
    }
}
